import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_HOUSEHOLD_GET_RENTER_PROFILE } from 'api/actionTypes';

export default async function loadRenterProfile(
  { state, apiClient },
  { userId, forceRefresh = false },
) {
  typeCheck('userId::PositiveNumber', userId);
  const renterProfileStatePath = ['household', 'renterProfilesByUserId', String(userId)];
  if (state.exists(renterProfileStatePath) && !forceRefresh) {
    return state.get(renterProfileStatePath);
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_RENTER_PROFILE,
    queryId: String(userId),
    state: state,
    payload: {
      userId: userId,
      createIfNotExists: true,
    },
    onSuccess(renterProfile) {
      state.set(renterProfileStatePath, renterProfile);
    },
  });
}
